import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'root',
            component: Home
        },
        {
            path: '/form-codi',
            name: 'form-codi',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "form-codi" */ './views/FormCodi.vue')
        },
        {
            path: '/home',
            name: 'home',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
        },
        {
            path: '/fitxar',
            name: 'fitxar',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "fitxar" */ './views/Fitxar.vue')
        }
    ]
})

/**
 * Middleare per comprovar si podem mostrar la vista que ens demanen
 */
router.beforeEach((to, from, next) => {

    //Carreguem la info que tenim guardada al localStorage
    store.dispatch('getStorage');

    console.log('MIDDLEWARE', store.state);

    if (to.name != 'form-codi'){ //Si la vista no és form-codi, comprovem si la podem mostrar

        //console.log('Desde el nuddleware', store.state.appObject)

        //if(!store.state.authenticated || !store.getters.isAuthenticated){
        if(!store.state.appObject || !store.state.authenticated){
            router.push('form-codi') //Redirigim a la vista de l'entrada de codi (no tenim dades al localstorage o les hem perdut)
        }else{
            next()
        }

        //Cridem directament una funció de l'store per saber si tenim la informació guardada
/*        store.dispatch('getStorage')
        .then( data => {
            console.log( data)
            next() //Mostrem la vista
        })
        .catch( err => {
            console.log( err )
            router.push('form-codi') //Redirigim a la vista de l'entrada de codi (no tenim dades al localstorage o les hem perdut)
        })*/
    }
    else next() //Sinó és cap de les rutes anteriors, deixem entrar sense problemes
})

export default router
